export default {
  businessDetailsTitle: {
    id: 'bo_seller.kyb.review.business_details_title',
    defaultMessage: 'Business details',
  },
  businessDetailsLegalName: {
    id: 'bo_seller.kyb.review.business_details_legal_name',
    defaultMessage: 'Legal business name',
  },
  businessDetailsTradeName: {
    id: 'bo_seller.kyb.review.business_details_trade_name',
    defaultMessage: 'Trade business name',
  },
  businessDetailsRegistrationCountry: {
    id: 'bo_seller.kyb.review.business_details_country_of_registration',
    defaultMessage: 'Country of registration',
  },
  businessDetailsRegistrationType: {
    id: 'bo_seller.kyb.review.business_details_registration_type',
    defaultMessage: 'Registration type',
  },
  businessDetailsRegistrationNumber: {
    id: 'bo_seller.kyb.review.business_details_registration_number',
    defaultMessage: 'Registration number',
  },
  businessDetailsIncorporationDate: {
    id: 'bo_seller.kyb.review.business_details_incorporation_date',
    defaultMessage: 'Incorporation date',
  },
  businessDetailsHeadquartersAddress: {
    id: 'bo_seller.kyb.review.business_details_headquarters_address',
    defaultMessage: 'Headquarters address',
  },
  certificateOfIncorporation: {
    id: 'bo_seller.kyb.review.business_details_certificate_of_incorporation',
    defaultMessage: 'Certificate of incorporation',
  },
  businessDetailsInvestedCapital: {
    id: 'bo_seller.kyb.review.business_details_invested_capital',
    defaultMessage: 'Capital invested at incorporation',
  },
  businessDetailsInvestedCapitalCurrency: {
    id: 'bo_seller.kyb.review.business_details_invested_capital_currency',
    defaultMessage: 'Capital invested currency',
  },
  businessDetailsEditButton: {
    id: 'bo_seller.kyb.review.business_details_edit_button',
    defaultMessage: 'Edit',
  },
  accountRequesterTitle: {
    id: 'bo_seller.kyb.review.account_requester_title',
    defaultMessage: 'Account requester details',
  },
  accountRequesterEditButton: {
    id: 'bo_seller.kyb.review.account_requester_edit_button',
    defaultMessage: 'Edit',
  },
  legalRepresentativeTitle: {
    id: 'bo_seller.kyb.review.legal_representative_title',
    defaultMessage: 'Legal representative details',
  },
  legalRepresentativeEditButton: {
    id: 'bo_seller.kyb.review.legal_representative_edit_button',
    defaultMessage: 'Edit',
  },
  beneficialOwnerPrimaryOwner: {
    id: 'bo_seller.kyb.review.beneficial_owner_primary_owner',
    defaultMessage: 'Primary beneficial owner details',
  },
  otherBeneficialOwnerOwnerDetails: {
    id: 'bo_seller.kyb.review.other_beneficial_owner_owner_details',
    defaultMessage: 'Other beneficial owner details',
  },
  beneficialOwnerEditButton: {
    id: 'bo_seller.kyb.review.beneficial_owner_edit_button',
    defaultMessage: 'Edit',
  },
  letterOfAuthorizationTitle: {
    id: 'bo_seller.kyb.review.letter_of_authorization_title',
    defaultMessage: 'Letter of authorization',
  },
  letterOfAuthorizationEditButton: {
    id: 'bo_seller.kyb.review.letter_of_authorization_edit_button',
    defaultMessage: 'Edit',
  },
} as const
